import React, { FC, useState, useEffect } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import { Box } from '@wix/design-system';
import MobileFilterButton from '../MobileFilters/MobileFilterButton';
import s from './MobileFiltersAndActions.module.scss';

const MobileFiltersAndActions: FC = () => {
  const { isIntersecting, ref } = useIntersectionObserver({});

  const [showShadow, setShowShadow] = useState(false);
  useEffect(() => {
    if (isIntersecting) {
      setShowShadow(true);
    } else {
      setShowShadow(false);
    }
  }, [isIntersecting]);

  return (
    <div
      className={showShadow ? `${s.stickyNav} ${s.showShadow}` : s.stickyNav}
      ref={ref}
    >
      <Box margin="0 auto" maxWidth="504px">
        <Box paddingTop="2px" height="54px" verticalAlign="middle">
          <Box align="left" gap="SP2">
            <MobileFilterButton />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default MobileFiltersAndActions;
